import { render, staticRenderFns } from "./crudCategories.vue?vue&type=template&id=220444cb&"
import script from "./crudCategories.vue?vue&type=script&lang=js&"
export * from "./crudCategories.vue?vue&type=script&lang=js&"
import style0 from "./crudCategories.vue?vue&type=style&index=0&id=220444cb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports